module.exports = __webpack_public_path__ + "img/de.4d7bac3b.svg";